import { useAuthContextUser } from "context/AuthContext";
import React, { useContext, useEffect, useState } from "react";
import { GlobalAlertContext } from "context/GlobalAlertContext";
import MCSOverlayLoading from "components/MCSOverlayLoading";
import MCSGridRevert from "components/MCSGridRevert";
import { ButtonText, Col, Form, FormControl, Icon, Input, InputOption, Row, Typography } from "@visa/vds";
import { trackPromise, usePromiseTracker } from "react-promise-tracker";
import { certificationPackageListService } from "services/certification.packageList";
import AdminCertificationPackagesList from "./AdminCertificationPackagesList";
import { DateHelper } from "_helpers/DateHelper";
import { FileHelper } from "_helpers/FileHelper";

const AdminCertificationPackagesPage = () => {
    const alertContext = useContext(GlobalAlertContext);
    const user = useAuthContextUser();
    const searchHelpText = "Search matches on the following fields: Package ID, BID, Business Name, Package Name, Compliance Letter"
    const { promiseInProgress } = usePromiseTracker();
    const [pagination, setPagination] = useState({ current: 1, pageSize: 10, total: 0 })
    const [filters, setFilters] = useState({
        implementationType: [],
        protocolVersion: [],
        packageState: [1, 2, 3, 4, 5, 6, 7],
        vstsAccess: [],
        search: "",
        sorting: "lastUpdatedOn desc"
    });

    const defaultSorter = { columnKey: "lastUpdatedOn", order: "descend" }
    const [searchValue, setSearchValue] = useState("");
    const [typingTimeOut, setTypingTimeout] = useState({ name: "", timeout: 0 });
    const [sorter, setSorter] = useState(defaultSorter)
    const [data, setData] = useState("");

    const getAllFilters = (filters, searchValue, sorter, skipCount) => {
        const sort = sorter.order == null ? "null" : sorter.order == "descend" ? sorter.order.substring(0, 4) : sorter.order.substring(0, 3);
        return {
            ...filters,
            skipCount: skipCount,
            search: searchValue,
            sorting: `${sorter.columnKey == "implementationType" ? "implementationId" : sorter.columnKey} ${sort}`
        };
    };

    const fetchData = (pagination, filters, newSearchValue, sorter) => {
        setSorter(sorter)

        // let sort = sorter && sorter.order == null ? "null" : sorter.order == "descend" ? sorter.order.substring(0, 4) : sorter.order.substring(0, 3)
        let skipCount = (pagination.current - 1) * pagination.pageSize;
        const allFilters = getAllFilters(filters, newSearchValue, sorter, skipCount);
        setFilters(filters)
        setSearchValue(newSearchValue)

        trackPromise(
            certificationPackageListService.AdminGetAllPackages(allFilters)
                .then(result => {
                    var data = result.data.items
                    var fullVstsAccessDescription = data.map((item) => {
                        let fullVstsAccessDescription = item.vstsAccess.vstsAccess == true
                            ? "Active " + item.vstsAccess.vstsAccessDescriptionText
                            : "Inactive " + item.vstsAccess.vstsAccessDescriptionText

                        item.packageOuterTable = { ...item.packageOuterTable, fullVstsAccessDescription: fullVstsAccessDescription }
                        if (item.vstsAccess.mergedStartDate != null && item.vstsAccess.mergedEndDate != null) {
                            item.packageInnerTable = { ...item.packageInnerTable, subscriptionDates: DateHelper.ToFormattedDate(item.vstsAccess.mergedStartDate) + " to " + DateHelper.ToFormattedDate(item.vstsAccess.mergedEndDate) }
                        }
                        return item
                    })
                    setData(fullVstsAccessDescription)
                    setPagination({ ...pagination, total: result.data.totalCount })
                })
                .catch(error => alertContext.setGlobalErrorMessage("Error getting packages."))
        )
    }

    const handleManualSearch = (event) => {
        setSearchValue(event.target.value);
        if (event.key === 'Enter') {
            event.preventDefault();
            handleSearchChange(event.target.value);
            clearTimeout(typingTimeOut.timeout);
        }
    }

    const handleSearchChange = async (newSearchValue) => {
        setPagination({ ...pagination, current: 1 })
        setSearchValue(newSearchValue)
        fetchData({ ...pagination, current: 1 }, filters, newSearchValue, sorter);
    }

    const handleAutoSearch = (value) => {
        setSearchValue(value);
        if (typingTimeOut.timeout) {
            clearTimeout(typingTimeOut.timeout);
        }
        setTypingTimeout({
            name: searchValue,
            timeout: window.setTimeout(() => handleSearchChange(value), 1500),
        });
    }

    const handleExport = () => {
        const allFilters = getAllFilters(filters, searchValue, sorter, 0);
        trackPromise(
            certificationPackageListService.AdminExport(allFilters)
                .then(response => FileHelper.DownloadFile(response))
                .catch(error => alertContext.setGlobalErrorMessage("Error exporting packages."))
        );
    };

    useEffect(() => {
        fetchData(pagination, filters, searchValue, defaultSorter)
    }, [])


    return (
        <>
            <GlobalAlertContext.Consumer>
                {(alertObj) => (
                    <>
                        {promiseInProgress && <MCSOverlayLoading />}
                        <MCSGridRevert style={{ marginLeft: "20px" }}>
                            <Row>
                                <Typography style={{ marginLeft: "5px", color: "#1434CB" }} tag="h1" variant="headline">Certification Package List</Typography>
                            </Row>
                            <Row>
                                <Col></Col>
                                {user && (user.isSuperAdmin || user.isVstsWorkflowAdmin) &&
                                    <Col alignEnd textAlign="right">
                                        <ButtonText onClick={handleExport}>Export</ButtonText>
                                    </Col>
                                }
                                <Col>
                                    <Form>
                                        <FormControl position="right">
                                            <Input
                                                contentBeforeInput={
                                                    <InputOption>
                                                        <Icon
                                                            name="search"
                                                            resolution="low"
                                                            style={{ cursor: "pointer" }}
                                                        />
                                                    </InputOption>
                                                }
                                                helpText={searchHelpText}
                                                name="search"
                                                value={searchValue}
                                                showHelpText
                                                onKeyPress={handleManualSearch}
                                                onChange={(e) => handleAutoSearch(e.target.value)}
                                            />
                                        </FormControl>
                                    </Form>
                                </Col>
                            </Row>
                            <Row style={{ marginTop: "-15px" }}>

                            </Row>
                            <Row>
                                <AdminCertificationPackagesList
                                    data={data}
                                    handleChangeFilter={fetchData}
                                    pagination={pagination}
                                    filters={filters}
                                    search={searchValue}
                                    sorter={sorter}
                                />
                            </Row>
                        </MCSGridRevert>
                    </>
                )
                }
            </GlobalAlertContext.Consumer >
        </>
    )
}

export default AdminCertificationPackagesPage;